module.exports = __webpack_public_path__ + "static/media/user_8.4e3d26e9.png";